module.exports = __webpack_public_path__ + "static/media/Fermo.690bb5a5.png";